"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface CustomerMappingsCardProps {
  mappings: Array<{ customerId: string; realmId?: string }>;
  onRemove: (customerId: string) => void;
  getDisplayNameForCustomer: (customerId: string) => string;
  isRemoving?: boolean;
}

export function CustomerMappingsCard({
  mappings,
  onRemove,
  getDisplayNameForCustomer,
  isRemoving = false,
}: CustomerMappingsCardProps) {
  if (mappings.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">QuickBooks Customer Mappings</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {mappings.map((mapping, index) => (
            <div key={index} className="flex items-center justify-between p-2 border rounded">
              <div>
                <span className="font-medium">{getDisplayNameForCustomer(mapping.customerId)}</span>
                <span className="text-sm text-muted-foreground ml-2">({mapping.customerId})</span>
                {mapping.realmId && (
                  <span className="text-sm text-muted-foreground ml-2">- {mapping.realmId}</span>
                )}
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onRemove(mapping.customerId)}
                disabled={isRemoving} title="Close"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
